import gb from './gb'

interface CountyRegion {
  name: string
  values: County[]
}

interface County {
  name: string
  abbreviation: string
}

interface CountryCounties {
  [key: string]: CountyRegion[]
}

const countryCounties: CountryCounties = {
  gb,
}

export default countryCounties